var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.modalData
        ? _c(
            "EmptyModal",
            {
              attrs: { onModalClose: _vm.closeModal, modalData: _vm.modalData },
            },
            [
              _vm._t("default", function () {
                return [
                  _c("img", {
                    staticClass: "w-100",
                    attrs: { src: _vm.modalData.source, alt: "" },
                  }),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.blockUpload
        ? _c("label", { attrs: { for: "filesUpload" } }, [
            _c(
              "span",
              {
                staticClass: "btn btn-outline-info",
                attrs: { type: "button" },
              },
              [_vm._v("Выбрать файлы для загрузки")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        ref: "file",
        staticClass: "hidden",
        attrs: {
          type: "file",
          id: "filesUpload",
          accept: "image/x-png,image/gif,image/jpeg,application/pdf",
          multiple: "multiple",
        },
        on: { change: _vm.readMultiFiles },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-wrap" },
        _vm._l(_vm.uploadedFiles, function (img, i) {
          return !img.to_delete && !img.type
            ? _c(
                "div",
                {
                  key: i,
                  class: { img_div: true, img_small_div: _vm.smallPhotos },
                },
                [
                  _vm.allowToDelete
                    ? _c(
                        "button",
                        {
                          staticClass: "btn del_btn btn-danger btn-xs",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.removeFile(i)
                            },
                          },
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-trash" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  img.source
                    ? [
                        _c("img", {
                          staticClass: "imagePreviewWrapper pointer",
                          attrs: { src: img.source, alt: "" },
                          on: {
                            click: function ($event) {
                              return _vm.openImage(img)
                            },
                          },
                        }),
                      ]
                    : [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex files_preview justify-content-center align-items-center",
                          },
                          [
                            _c("LoadingButton", {
                              attrs: {
                                title: "Показать фото",
                                className: "btn btn-outline-success btn-xs",
                                onClick: () => _vm.loadImage(i),
                                loading: _vm.loadingImage[img.id],
                                color: _vm.$constants.SUCCESS_COLOR,
                                type: "button",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                  _vm._v(" "),
                  img.details
                    ? _c(
                        "div",
                        {
                          staticClass: "img_details text-right text-muted pr-1",
                        },
                        [
                          !_vm.showImages && !img.is_active
                            ? _c(
                                "span",
                                { staticClass: "badge badge-warning" },
                                [_vm._v("файл удален")]
                              )
                            : _vm._e(),
                          _vm._v(
                            "\n        (" +
                              _vm._s(img.details.uploaded_by.user_name) +
                              ") " +
                              _vm._s(
                                _vm.printDate(
                                  img.created_at,
                                  "DD.MM.YYYY HH:mm"
                                )
                              ) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              )
            : _vm._e()
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        _vm._l(_vm.uploadedFiles, function (f, i) {
          return f.type === 4
            ? _c(
                "div",
                { staticClass: "flex flex_gap_10 mb-1" },
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "скачать",
                      className: "btn btn-outline-success btn-xs",
                      onClick: () => _vm.downloadFile(f),
                      loading: _vm.loadingImage[f.id],
                      color: _vm.$constants.SUCCESS_COLOR,
                      type: "button",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _c("strong", [_vm._v("СДЭК Стикер")]),
                    _vm._v(" " + _vm._s(_vm.printDate(f.created_at))),
                  ]),
                ],
                1
              )
            : _vm._e()
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }